// BillingSeatsCard.js
import { useEffect, useState } from 'react';
import { facilityApi } from '../../api/api';
import { seatsUsed } from '../../utils/billingStatus';

export default function BillingSeatsCard({ facilityId, seatLimit }) {
    const [state, setState] = useState({ loading: true, error: null, members: [], invites: [] });
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let cancelled = false;
        setState((s) => ({ ...s, loading: true, error: null }));
        Promise.all([facilityApi.listMembers(facilityId), facilityApi.listInvites(facilityId)])
            .then(([members, invites]) => { if (!cancelled) setState({ loading: false, error: null, members, invites }); })
            .catch((error) => { if (!cancelled) setState((s) => ({ ...s, loading: false, error })); });
        return () => { cancelled = true; };
    }, [facilityId, attempt]);

    const pending = state.invites.filter((i) => !i?.used).length;
    const used = seatsUsed(state.members, state.invites);
    const full = seatLimit != null && used >= seatLimit;
    return (
        <section className="billing-card">
            <h2 className="billing-card-title">Seats</h2>
            {state.loading ? <div className="billing-loading">Loading…</div>
             : state.error ? (
                <div className="billing-error">
                    Could not load seats.{' '}
                    <button type="button" className="billing-link-btn" onClick={() => setAttempt((n) => n + 1)}>Retry</button>
                </div>
            )
             : (
                <>
                    <div className={`billing-stat${full ? ' billing-stat--full' : ''}`}>{seatLimit != null ? `${used} of ${seatLimit}` : `${used}`}</div>
                    <p className="billing-card-detail">{state.members.length} member{state.members.length === 1 ? '' : 's'}, {pending} pending invite{pending === 1 ? '' : 's'}. Pending invites hold a seat.</p>
                </>
            )}
        </section>
    );
}
